import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSurgerySegments, selectIssueDesc, selectSurgeryDate } from '@store/order/selectors';
import { SEGMENT_ENUM_TRANSLATION_KEYS, isSegmentsEnum } from '@pages/order/surgery-info/SegmentsEnum';




const SurgeryInfo = () => {
	const { t } = useTranslation([ 'forms', 'global' ]);

	const surgerySegments = useSelector(selectSurgerySegments);
	const issueDesc = useSelector(selectIssueDesc);
	const surgeryDate = useSelector(selectSurgeryDate);

	return (
		<>
			{surgerySegments && surgerySegments.length > 0 &&
				<div className='order-summary-element'>

					<h2>{t('surgeryInfo.segments.summaryLabel')}</h2>

					<div className='summary-property'>
						<p>{surgerySegments
							.map(segment => isSegmentsEnum(segment) ? t(SEGMENT_ENUM_TRANSLATION_KEYS[segment]) : segment)
      						.join(', ')}
						</p>
					</div>

				</div>}
			
			
			{issueDesc && issueDesc.length > 0 &&
				<div className='order-summary-element'>

					<h2>{t('surgeryInfo.info.summaryLabel')}</h2>

					<div className='summary-property'>
						<p>{issueDesc ? issueDesc : '-'}</p>
					</div>

				</div>}


			<div className='order-summary-element'>

				<h2>{t('surgeryInfo.date.sectionLabel')}</h2>

				<div className='summary-property'>
					<p>{surgeryDate ? new Intl.DateTimeFormat(t('languageIntlCode', { ns: 'global' })).format(new Date(surgeryDate)) : '-'}</p>
				</div>

			</div>
		</>
	);
};

export default SurgeryInfo;